import React from 'react';
import { Row, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
//translations
import { useTranslation } from 'react-i18next';
//zustand stores
import { useCartStore, useUserStore, useCompanyStore } from 'stores';
//api
import { updateCartDetails, createOrderBeforePayment } from 'api/ecommerce';

const TPV = ({ redsys = null, infoDataDisabled = false }) => {
  const { t } = useTranslation(['payment', 'shipping']);
  const { id: bookstoreId } = useCompanyStore();
  const { benefitedBookstore, pickUpLibrary, isConcourseUser } = useUserStore();
  const { isStorePickup, items, billingCartAddress, shippingCartAddress, contactInfo, total, clear } = useCartStore();
  const navigate = useNavigate();
  
  // Validar que el total sea mayor que 0
  const isTotalValid = total != null && total > 0;
  

  const routeRedsysHistory = () => {
    if (!localStorage.getItem('historyRedsys')) {
      localStorage.setItem('historyRedsys', redsys.Target_Url.includes('redsys'));
    }
  };

  const handleUpdateCartDetails = async () => {

    const payload = {
      items: items,
      empresa: bookstoreId,
      store_pickup: isStorePickup,
      billing_address: billingCartAddress,
      shipping_address: shippingCartAddress,
      bookstore_to_pickup: pickUpLibrary,
      benefited_company: benefitedBookstore?.value,
      contact_info: contactInfo,
    }
    try {
      const response = await updateCartDetails(payload);
      console.log('Cart details updated', response);
      
    } catch (error) {
      console.error('Error updating cart details', error);
    }
  };

  const handleSubmitRedsys = async(event) =>{
    event.preventDefault();
    // Validar que el total sea mayor que 0
    if (!isTotalValid) {
      return;
    }
    
    // Si es cliente concurso, redirigir directamente a orderConfirmation
    if (isConcourseUser) {
      try {
        await handleUpdateCartDetails();
        navigate('/pago-ok');
        return;
      } catch (error) {
        console.error('Error updating cart details:', error);
        return;
      }
    }
    
    routeRedsysHistory();
    try {
      await handleUpdateCartDetails();
      const { status } = await createOrderBeforePayment();
      if (status === 200) {
        clear();
        const form = document.getElementById('redsys');
        form.submit();
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  }

  // Si es cliente concurso, mostrar botón directamente sin necesidad de redsys
  if (isConcourseUser) {
    return (
      <>
        {infoDataDisabled || !isTotalValid ?
          <OverlayTrigger
            overlay={
              <Tooltip id="button-tooltip2">
                {!isTotalValid 
                  ? t('totalMustBeGreaterThanZero')
                  : t('completeFields', { ns: 'shipping' })
                }
              </Tooltip>
            }
          >
            <span className="d-inline-block">
              <Button
                className="checkout-btn checkout-btn--primary disabled"
                onClick={(e) => handleSubmitRedsys(e)}
                disabled
              >
                {t('finishPurchase')} →
              </Button>
            </span>
          </OverlayTrigger> :
          <Button
            className="checkout-btn checkout-btn--primary"
            onClick={(e) => handleSubmitRedsys(e)}
            disabled={!isTotalValid}
          >
            {t('finishPurchase')} →
          </Button>
        }
      </>
    );
  }

  // Si no es cliente concurso, mostrar formulario normal de Redsys
  return (
    <>
      {redsys ? (
        <>
          <form id="redsys" name="from" action={redsys.Target_Url} method="POST">
            <input type="hidden" name="Ds_SignatureVersion" value={redsys.Ds_SignatureVersion} />
            <input type="hidden" name="Ds_MerchantParameters" value={redsys.Ds_MerchantParameters} />
            <input type="hidden" name="Ds_Signature" value={redsys.Ds_Signature} />
            {infoDataDisabled || !isTotalValid ?
              <OverlayTrigger
                overlay={
                  <Tooltip id="button-tooltip2">
                    {!isTotalValid 
                      ? t('totalMustBeGreaterThanZero')
                      : t('completeFields', { ns: 'shipping' })
                    }
                  </Tooltip>
                }
              >
                <span className="d-inline-block">
                  <Button
                    type="submit"
                    name="enviar"
                    className="checkout-btn checkout-btn--primary disabled"
                    onClick={(e) => handleSubmitRedsys(e)}
                    disabled
                  >
                    {t('finishPurchase')} →
                  </Button>
                </span>
              </OverlayTrigger> :
              <Button
                type="submit"
                name="enviar"
                className="checkout-btn checkout-btn--primary"
                onClick={(e) => handleSubmitRedsys(e)}
                disabled={!isTotalValid}
              >
                {t('finishPurchase')} →
              </Button>}
          </form>
        </>
      ) : (
        <Row>{t('processing')}</Row>
      )}
    </>
  );
};

export default TPV;
